import React from 'react';
import UserProfileCard from '../../components/UserProfileCard';
import CardGrid from '../../components/CardGrid';

const profile = {
  imageUrl: 'https://picsum.photos/seed/profile/60/60',
  name: 'Jane Doe',
  phone: '(555) 123-4567',
  joined: '2023-01-15',
};

const banner = {
  status: 'Covid',
  result: 'Negative',
  lastUpdated: '05/09/2025',
};

const cardData = [
  { id: 'card-0', title: 'Active Problems', text: 'Hypertension (I10), Type 2 Diabetes (E11.9), Asthma (J45.909)' },
  { id: 'card-1', title: 'Allergies/Reactions', text: 'Penicillin (Rash), Shellfish (Anaphylaxis), Latex (Contact Dermatitis)' },
  { id: 'card-2', title: 'Postings', text: 'Advance Directive on file. Organ Donor: Yes. DNR: Not on file.' },
  { id: 'card-3', title: "Women's Health", text: 'Last Pap Smear: 2023-03-15 (Normal). Last Mammogram: 2022-11-01 (BI-RADS 1).' },
  { id: 'card-4', title: 'Active Medications', text: 'Lisinopril 10mg (1 daily), Metformin 500mg (2 daily), Albuterol Inhaler (PRN)' },
  { id: 'card-5', title: 'Recent Lab Reports', text: 'CBC (2024-05-01): WNL. Lipid Panel (2024-05-01): LDL 130mg/dL (High). A1c (2024-04-15): 7.2%.' },
  { id: 'card-6', title: 'Clinical Reminders', text: 'Flu Vaccine: Due Sep 2024. Colonoscopy: Due 2027. Eye Exam: Overdue (Last: 2022-01-10).' },
  { id: 'card-7', title: 'Recent Encounters', text: '2024-05-10: Dr. Smith (Follow-up). 2024-03-15: Dr. Lee (Annual Physical).' },
  { id: 'card-8', title: 'Vitals (Last)', text: 'BP: 135/85 mmHg, HR: 72 bpm, Temp: 98.6°F, SpO2: 98% (2024-05-10)' },
  { id: 'card-9', title: 'Appointments', text: 'Next: 2024-08-15 - Dr. Green (Dental). Scheduled: 2024-11-20 - Dr. Smith (Cardiology Follow-up).' }
];

const UserProfile = () => (
  <>
    <UserProfileCard profile={profile} banner={banner} />
    {/* <CardGrid cardData={cardData} /> */}
  </>
);

export default UserProfile;
